import { Soshiki } from 'src/types/common/Soshiki';
import { StatusColor } from 'src/types/common/statusColor';

export enum ShelterTypeCode {
  Home = '1',
  Shelter = '2',
  Other = '3',
  Unknown = '4',
}

export enum PlannedShelterTypeCode {
  Home = '1',
  Shelter = '2',
  Other = '3',
}

export type PlannedShelter = {
  disasterTypeNumber: number;
  disasterTypeName: string;
  shelterTypeCode?: PlannedShelterTypeCode;
  shelterId?: string;
  shelterName?: string;
  shelterAddress?: string;
  customShelterName?: string;
  customShelterAddress?: string;
};

export type AdditionalItems = {
  additionalItemIndex: number;
  additionalItemName: string;
  additionalItemValue?: string;
};

export type ShienKankei = { shienKankeiId: string; spId?: string; soshikiId?: string };

export type PrsItemSetting = {
  prsItemKey: string;
  displayFlg: boolean;
};

export type AdditionalItemSetting = {
  additionalItemIndex: number;
  additionalItemName: string;
};


export type Prs2 = {
  prsId: string;
  evaPrsId: number;
  fName: string;
  sName: string;
  kfName: string;
  ksName: string;
  status?: string;
  sex?: string;
  birthday?: string;
  telNo?: string;
  address?: string;
  subAddress?: string;
  agreement?: boolean;
  prsKubun?: string;
  familyStructure?: string;
  solitudeCohabitation?: string;
  primaryDoctor?: string;
  physicalDisabilityCertificate?: string;
  rehabilitationNotebook?: string;
  mentalDisabilityHealthAndWelfareHandbook?: string;
  nursingCareLevel?: string;
  intractableDisease?: string;
  emergencyContactName?: string;
  emergencyContactRelationship?: string;
  emergencyContactAddress?: string;
  emergencyContactPhoneNumber?: string;
  supporterRemarks?: string;
  prsStatusId: string;
  prsStatusName: string;
  prsStatusColor: StatusColor;
  prsStatusSortOrder: number;
  customShelterName?: string;
  shelterTypeCode?: ShelterTypeCode;
  shelterId?: string;
  shelterName?: string;
  prsMemo?: string;
  jichitaiId: string;
  jichitaiName: string;
  lastPrsStatusUpdatedAt?: string;
  lastCalledAt?: string;
  lastVisitedAt?: string;
  lastEvacuatedAt?: string;
  delFlg: boolean;
  zip?: string;
  residentAgreement?: string;
  municipalityAgreement?: string;
  telNo2?: string;
  fax?: string;
  travelMedicine?: string;
  emergencyContactPhoneNumber2?: string;
  emergencyContactNameKana?: string;
  emergencyContactSolitudeCohabitation?: string;
  emergencyContact2Name?: string;
  emergencyContact2Relationship?: string;
  emergencyContact2Address?: string;
  emergencyContact2PhoneNumber?: string;
  emergencyContact2PhoneNumber2?: string;
  emergencyContact2NameKana?: string;
  emergencyContact2SolitudeCohabitation?: string;
  emergencyContact3Name?: string;
  emergencyContact3Relationship?: string;
  emergencyContact3Address?: string;
  emergencyContact3PhoneNumber?: string;
  emergencyContact3PhoneNumber2?: string;
  emergencyContact3NameKana?: string;
  emergencyContact3SolitudeCohabitation?: string;
  soshiki: Soshiki[];
  shienKankei: ShienKankei[];
  plannedShelters: PlannedShelter[];
  additionalItems: AdditionalItems[];
};
